export default "__VITE_ASSET__CohITc44__"